"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/FaqAndRating.scss");
require("./modules/faq");
require("./modules/rating");
